import { NavLink } from "react-router-dom";
import type { FC } from "react";

export const NotFound: FC = () => {
  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 12,
        padding: 32,
      }}
    >
      <div style={{ fontSize: "4rem", opacity: 0.5 }}>⊘</div>
      <div
        style={{
          fontSize: "3rem",
          fontWeight: 800,
          color: "var(--vmx-danger)",
        }}
      >
        404
      </div>
      <div
        style={{
          fontSize: "1.25rem",
          fontWeight: 600,
          color: "var(--vmx-gray-700)",
        }}
      >
        Page Not Found
      </div>
      <div
        style={{
          fontSize: "0.875rem",
          color: "var(--vmx-gray-500)",
          marginBottom: 12,
        }}
      >
        Sorry, the page you are looking for does not exist or has been moved.
      </div>
      <NavLink to="/">
        <button className="vmx-btn vmx-btn-primary">Go to Dashboard</button>
      </NavLink>
    </div>
  );
};
